module.exports = __webpack_public_path__ + "static/media/logica.609f1ba2.jpeg";